import { CLUBS_ROUTE } from '../constants/route.constants';
import {
  getParsedRouteParam,
  encodeRouteParam
} from '../utility/parseRouteParams';

const toUrlFriendlyName = path => {
  return getParsedRouteParam(path);
};

export const parseClubUrl = ({ name, country, state }) => {
  const c = toUrlFriendlyName(country);
  const s = toUrlFriendlyName(state);
  const n = toUrlFriendlyName(name);
  return `${CLUBS_ROUTE}/${c}/${s}/${n}`;
};

export const encodeClubUrl = ({ name, country, state }) => {
  const c = encodeRouteParam(country);
  const s = encodeRouteParam(state);
  const n = encodeRouteParam(name);
  return `${CLUBS_ROUTE}/${c}/${s}/${n}`;
};

export const parseStateUrl = ({ country, state }) => {
  const c = toUrlFriendlyName(country);
  const s = toUrlFriendlyName(state);
  return `${CLUBS_ROUTE}/${c}/${s}`;
};

export const encodeStateUrl = ({ country, state }) => {
  const c = encodeRouteParam(country);
  const s = encodeRouteParam(state);
  return `${CLUBS_ROUTE}/${c}/${s}`;
};

export const parseCountryUrl = country => {
  return `${CLUBS_ROUTE}/${toUrlFriendlyName(country)}`;
};

export const encodeCountryUrl = country => {
  return `${CLUBS_ROUTE}/${encodeRouteParam(country)}`;
};

export const getFriendlyTeamName = team => {
  switch (team.code) {
    case 'Football':
      return team.gender === 'Female' ? 'Ladies Football' : 'Mens Football';
    case 'Camoige':
      return 'Camogie';
    default:
      return team.code;
  }
};

export const getTeamCssClass = team => {
  switch (team.code) {
    case 'Hurling':
      return 'team-type hurling';
    case 'Camoige':
      return 'team-type camoige';
    case 'Football':
      const cssClass =
        team.gender === 'Female' ? 'football-ladies' : 'football';
      return `team-type  ${cssClass}`;
    default:
      return '';
  }
};



// WEBPACK FOOTER //
// ./src/helpers/clubHelper.js